  @if (['partner'].includes(role())) {
    <h2>{{ 'partner.createOffer' | translate }}</h2>
    <div class="ion-margin-top">
      <ion-button color="light"
        (click)="createOffer()">{{ 'general.create' | translate }}</ion-button>
    </div>
  }
  @for (offer of offers$ | async; track offer.guid) {
    <ion-item lines="none"
      button="true"
      (click)="onOffer(offer)">
      <div>
        {{ offer.contractorName }}<br />
        <ion-note>{{ offer.partner.name }}</ion-note>
      </div>
      <span slot="end">
        {{ offer.date | timestamp:'d.M.yyyy' }}
      </span>
    </ion-item>
  }